import { FC, Fragment } from 'react';
import { Noop } from 'react-hook-form';

import { IonCheckbox } from '@ionic/react';

import group from '../../_styles/group.module.scss';

interface FormCheckboxInputProps {
  label: string;
  onBlur: Noop;
  value: boolean;
  multiline: boolean;
  onOuterChange: (v: boolean) => void;
  onInnerChange: (v: boolean) => void;
}

export const FormCheckboxInput: FC<FormCheckboxInputProps> = ({
  label,
  value,
  onBlur,
  onInnerChange,
  onOuterChange,
}) => {
  const handleOnChange = (v: boolean) => {
    onInnerChange(v);
    onOuterChange(v);
  };

  return (
    <Fragment>
      <IonCheckbox
        slot="start"
        value={value}
        checked={value}
        onIonBlur={onBlur}
        labelPlacement="end"
        className={group.control}
        onIonChange={({ detail: { checked } }) => handleOnChange(checked)}
      >
        {label}
      </IonCheckbox>
    </Fragment>
  );
};
